export function getRandomId() {
  const id = ++idCounter;
  return `eag-${id}`;
}

let idCounter = 0;
